import React, { useRef, useState } from "react";
import ReactSelect from "../../../ui/reactSelect/index";
import { RunnerUpHeader, TableWork } from "../../../ui";
import { Validators } from "../../../library/utilities/Validator";
import "./Dashboard.css";
import {  useGetECiCeoDeoDashboardDataMutation } from "../../../services/announceElection"
import { useEffect } from "react";
import {  parseJwt } from '../../../components/utilities/utils';
import Table from "../../../ui/datatable/DataTable";
import { useGetStatesStatusForceWiseQuery } from "../../../services/reportsServices";
import MultiSelectCheckBox from "../../../ui/multiSelectCheckbox/MultiSelectCheckBox";
import DownloadInstruction from "./DownloadInstruction";
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";

const aCTableHeader = [
    "State Name",
    "AC No. & Name",
    "e-PB Transmission Status",
    "Total e-PB Transmitted",
    "Total e-PB Downloaded",
    // "Total e-PB Booked"
];
const pCTableHeader = [
    "State Name",
    "PC No. & Name",
    "e-PB Transmission Status",
    "Total e-PB Transmitted",
    "Total e-PB Downloaded",
    // "Total e-PB Booked"
];
const EciNewDashboard = () => {
     const [selected,setSelected] =useState([])
    const userRole = localStorage.userrole
    const [Error, setError] = useState({});
    const { data: getElectionAnnouncedState } = useGetStatesStatusForceWiseQuery("", { skip: (userRole !== "eci" && userRole !=="epba" && userRole !=="epbr") });
    const [postdetails, datap] = useGetECiCeoDeoDashboardDataMutation()
    const [acTabledata, setAcTabledata] = useState([]);
    const [pcTabledata, setPcTabledata] = useState([]);
    const [totalNoOfRecordsAC,setTotalNoOfRecordsAC]=useState()
    const [totalNoOfRecordsPC,setTotalNoOfRecordsPC]=useState()
    const [state,setState]=useState();
    const [districtValue,setDistrictValue]=useState()
    const [skip, setSkip] = useState(true);
    const stateList = [];
    const [data, setData] = useState({
        stateValue: []
    }
    );
    const [count,setCount] = useState({acCount:{transmitted:0,notTransmitted:0},pcCount:{transmitted:0,notTransmitted:0}})
    const tableAcHeader = [];
    const columns1 = [
        {
            Header: "State Name",
            accessor: "col1",
        },
        {
            Header: "Election Type",
            accessor: "col2",
        },
        {
            Header: "AC No. & Name",
            accessor: "col3",
        },
        {
            Header: "e-PB Transmission Status",
            accessor: "col4",
        },
        {
            Header: "Total e-PB Transmitted",
            accessor: "col5",
        },
        {
            Header: "Total e-PB Downloaded",
            accessor: "col6",
        },
        // {
        //     Header: "Total e-PB booked",
        //     accessor: "col7",
        // },
    ];
    columns1.map((item) => {
        tableAcHeader.push(item.Header)
    })
    const tablePcHeader = [];
    const columns2 = [
        {
            Header: "State Name",
            accessor: "col1",
        },
        {
            Header: "Election Type",
            accessor: "col2",
        },
        {
            Header: "PC No. & Name",
            accessor: "col3",
        },
        {
            Header: "e-PB Transmission Status",
            accessor: "col4",
        },
        {
            Header: "Total e-PB Transmitted",
            accessor: "col5",
        },
        {
            Header: "Total e-PB Downloaded",
            accessor: "col6",
        },
        // {
        //     Header: "Total e-PB booked",
        //     accessor: "col7",
        // },
    ];
    columns2.map((item) => {
        tablePcHeader.push(item.Header)
    })
    const handleView = () => {
        let error = {};
        if (!selected || selected.length === 0) {
            error["stateValue"] = "This field is required";
        }
        if (Object.keys(error).length) {
            setError(error);
            return;
        }
        let stateListPayload = []
        selected?.map((item) => {
            stateListPayload.push(
                item.value
            )
        })
        postdetails({
            stateCdList: stateListPayload,
            districtCd: ""
        })
            .unwrap()
            .then((res) => {
                prepareData(res);
            })
            .catch((error) => {
            })

    }
    getElectionAnnouncedState?.payload?.map((item) => {
        stateList?.push({
            value: item.stateCd,
            label: item.stateName,
        });
    });
    const prepareData = (res) => {
        let tempAcTabledata = [];
        let tempPcTabledata = [];
        var actransCon = 0;
        var acnotTansCon = 0;
        var pctransCon = 0;
        var pcnotTansCon = 0;
        res?.payload?.map((item, i) => {
         
            if (item.constType === "AC") { 
                tempAcTabledata?.push({
                    "col1": item.stateName,
                    "col2": `${item.electionType} - AC`,
                    "col3": `${item.constNo ? item.constNo : ""}-${item.constName ? item.constName : ""}`,
                    "col4": <p className={item.epbGenerationStatus==="Yet to be Transmitted" ? "blink":"blink_completed"}>{item.epbGenerationStatus}</p>,
                    "col5": item.epbTransmitted ? item.epbTransmitted : "0",
                    "col6": item.epbDownloaded ? item.epbDownloaded : "0",
                    // "col7": item.epbBooked ? item.epbBooked : "NA",
                })
                item.epbGenerationStatus==="Yet to be Transmitted"?acnotTansCon = acnotTansCon +1:actransCon=actransCon+1;

            }
            if (item.constType === "PC") {
                tempPcTabledata?.push({
                    "col1": item.stateName,
                    "col2": `${item.electionType} - PC`,
                    "col3": `${item.constNo ? item.constNo : ""}-${item.constName ? item.constName : ""}`,
                    "col4": <p className={item.epbGenerationStatus==="Yet to be Transmitted" ? "blink":"blink_completed"}>{item.epbGenerationStatus}</p>,
                    "col5": item.epbTransmitted ? item.epbTransmitted : "0",
                    "col6": item.epbDownloaded ? item.epbDownloaded : "0",
                    // "col7": item.epbBooked ? item.epbBooked : "NA",
                })
                item.epbGenerationStatus==="Yet to be Transmitted"?pcnotTansCon = pcnotTansCon +1:pctransCon=pctransCon+1;

            }



        })
        setCount({acCount:{transmitted:actransCon,notTransmitted:acnotTansCon},pcCount:{transmitted:pctransCon,notTransmitted:pcnotTansCon}})
        setAcTabledata(tempAcTabledata);
        setTotalNoOfRecordsAC(tempAcTabledata.length)
        setPcTabledata(tempPcTabledata);
        setTotalNoOfRecordsPC(tempPcTabledata.length)
        setState( res?.state);
        setDistrictValue(res?.district)

    }

    useEffect(() => {
        if (userRole === "ceo"|| userRole === "ceoa") {
            let statecodedata = {
                stateCdList: [parseJwt(localStorage.access_token)?.authorizedStates?.[0]],
                districtCd: ""
            }
            postdetails(statecodedata)
                .unwrap()
                .then((res) => {
                    prepareData(res);
                })
                .catch((error) => {
                })
        }
        else if (userRole === "deo") {
            let statecodedata = {
                stateCdList: [parseJwt(localStorage.access_token)?.authorizedStates?.[0]],
                districtCd: parseJwt(localStorage.access_token)?.authorizedDistricts?.[0]
            }
            postdetails(statecodedata)
                .unwrap()
                .then((res) => {
                    prepareData(res);
                })
                .catch((error) => {
                })
        }

    }, [getElectionAnnouncedState])

    const handleChange = (key, value) => {
        setData((prevState) => ({
            ...prevState,
            [key]: value,
        }));
        setError([])
        setSkip(true);
    };

    const getError = (key, value) => {
        let error = { ...Error };
        if (value && value.message) {
            setError({ ...Error, [key]: value.message });
        } else {
            delete error[key];
            setError(error);
        }
    };


    return (
        <>
            <div className="container-fluid">
                <RunnerUpHeaderNew title={"e-PB Transmission Status"}
                state={
                            (localStorage.userrole==="ceo"||localStorage.userrole==="ceoa")?
                    <span
                   
                    >
                    State: {state}{" "}
                    </span>:(localStorage.userrole==="deo")?
                     <span
                     style={{
                     marginLeft: "105px",
                     color: "white",
                     fontSize: "18px",
                     }}
                     >
                     State: {state}{" "}
                     <span style={{ marginLeft: "13px" }}></span>District :{" "}
                      {districtValue}
                     </span>:null
                }
                
                        />
                {(localStorage.userrole === "eci"||localStorage.userrole === "epba" ||localStorage.userrole === "epbr") &&
                    <div className="row mb-2">
                        <div className="col-md-1  pt-4">
                            <label>State</label>
                        </div>
                        <div className="col-md-4">
                            <MultiSelectCheckBox
                                options={stateList}
                                className="mt-4"
                                name="stateValue"
                                value={selected}
                                onChange={setSelected}
                                labelledBy="Select"
                                validators={[
                                    {
                                        check: Validators.required,
                                        message: "This field is required",
                                    },
                                ]}
                                getError={(val) => getError("stateValue", val)}
                                Error={Error}
                            ></MultiSelectCheckBox>
                        </div>
                        {/* <div className="col-md-4">
                            <ReactSelect
                                labelClass=""
                                inputClass="col-md-12"
                                name="stateValue"
                                classNamePrefix="Select State"
                                isMulti={true}
                                value={data.stateValue}
                                placeholder="Select States"
                                handleChange={(val) => handleChange("stateValue", val)}
                                options={stateList}
                                validators={[
                                    {
                                        check: Validators.required,
                                        message: "This field is required",
                                    }
                                ]}

                                getError={(val) => getError("stateValue", val)}
                                Error={Error}
                            />

                        </div> */}
                        <div className="col-md-2 mt-4 ">
                            <button type="button"
                                className="btn btn-primary view-button"
                                onClick={handleView}>View
                            </button>
                        </div>
                    </div>
                }
                <div className="box ">
                    <div className="eci-dashboard-title">
                        <label className="font-weight-bold" style={{ position: "relative", left: "5px", fontSize: "large" }}>Assembly Constituency</label>
                        
                    </div>
                    <div style={{position:"relative",top:"45px", left:"30px"}} className="row"><label className="squareTick" style={{backgroundColor:"green"}}/> Transmitted :<span style={{marginLeft:"10px",marginRight:"10px"}}>{count.acCount.transmitted}</span><label className="squareTick" style={{backgroundColor:"rgb(247, 113, 3)"}}/> Yet To Be Transmitted :<span style={{marginLeft:"10px",marginRight:"10px"}}>{count.acCount.notTransmitted}</span> </div>
                    <div style={{ position: "relative", bottom: "30px" }}>
                        <Table
                            placeholder="Search"
                            globalsearch={true}
                            emptyMessage="No Record Found"
                            selectall={true}
                            columns={columns1}
                            data={acTabledata?.length === 0 ? [] : acTabledata}
                            size={5}
                            tableClassNameCheck="contenttable-eroll"
                            pagination
                            records
                            gotopage
                            rows
                            numberrows={totalNoOfRecordsAC}
                        />
                    </div>
                </div>
                <div className="box mt-5">
                    <div className="eci-dashboard-title">
                        <label className="font-weight-bold" style={{ position: "relative", left: "5px", fontSize: "large" }}>Parliamentary Constituency</label>
                    </div>
                    <div style={{position:"relative",top:"45px", left:"30px"}} className="row"><label className="squareTick" style={{backgroundColor:"green"}}/> Transmitted :<span style={{marginLeft:"10px",marginRight:"10px"}}>{count.pcCount.transmitted}</span><label className="squareTick" style={{backgroundColor:"rgb(247, 113, 3)"}}/> Yet To Be Transmitted :<span style={{marginLeft:"10px",marginRight:"10px"}}>{count.pcCount.notTransmitted}</span> </div>
                    <div style={{ position: "relative", bottom: "30px" }}>
                        <Table
                            placeholder="Search"
                            globalsearch={true}
                            emptyMessage="No Record Found"
                            selectall={true}
                            columns={columns2}
                            data={pcTabledata?.length === 0 ? [] : pcTabledata}
                            size={5}
                            tableClassNameCheck="contenttable-eroll"
                            pagination
                            records
                            gotopage
                            rows
                            numberrows={totalNoOfRecordsPC}
                        />
                    </div>
                </div>

<DownloadInstruction />
            </div>
        </>

    )

}


export default EciNewDashboard